import { useSocket } from '../context/SocketContext';

export const ReconnectingOverlay = () => {
	const { connected } = useSocket();

	// If we are connected, render nothing.
	if (connected) {
		return null;
	}

	// If we are disconnected, show the overlay.
	return (
		<div className='fixed inset-0 bg-black bg-opacity-75 flex flex-col items-center justify-center z-50'>
			<div className='w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin'></div>
			<p className='text-white text-xl mt-4'>Reconnecting...</p>
		</div>
	);
};
